/**
 * An email address whose format has been validated.
 *
 * It exists for addresses a user types. The address the wizard shows comes from the backend and is
 * never rebuilt here.
 */
export type Email = Readonly<{ value: string }>;

/** Format check only: no spaces, one `@`, and a domain with a dot. The backend checks the rest. */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Whether a candidate value is a valid email address. */
export const isEmailValid = (value: string): boolean => EMAIL_PATTERN.test(value.trim());

/** Creates an Email, trimmed. Throws when the format is not valid. */
export const createEmail = (value: string): Email => {
  if (!isEmailValid(value)) {
    throw new Error('Email is not a valid address');
  }

  return Object.freeze({ value: value.trim() });
};
